import {useCurrentRepository} from '@github-ui/current-repository'

import {useCurrentBlob} from '../../../hooks/CurrentBlob'
import styles from './BlobTopBanners.module.css'
import {DependabotConfigurationBanner} from './DependabotConfigurationBanner'
import {ActionsOnboardingPrompt, OrgOnboardingTip} from './OrgOnboardingTip'
import {PlanSupportBanner} from './PlanSupportBanner'

export default function BlobTopBanners() {
  const {planSupportInfo, topBannersInfo} = useCurrentBlob()
  const {actionsOnboardingTip} = topBannersInfo
  const repo = useCurrentRepository()

  return (
    <div className={styles.Box}>
      <PlanSupportBanner {...planSupportInfo} feature="codeowners" featureName="CODEOWNERS" />
      <DependabotConfigurationBanner />
      {actionsOnboardingTip && (
        <OrgOnboardingTip
          iconSvg={actionsOnboardingTip.iconSvg}
          mediaPreviewSrc={actionsOnboardingTip.mediaPreviewSrc}
          mediaUrl={actionsOnboardingTip.mediaUrl}
          taskTitle={actionsOnboardingTip.taskTitle}
          taskPath={actionsOnboardingTip.taskPath}
          org={actionsOnboardingTip.orgName}
        >
          <ActionsOnboardingPrompt owner={repo.ownerLogin} repo={repo.name} />
        </OrgOnboardingTip>
      )}
    </div>
  )
}

try{ BlobTopBanners.displayName ||= 'BlobTopBanners' } catch {}